import { Link } from "react-router-dom";
const PageHeader = ({
  pageTitle,
  count,
  addPageUrl,

}) => {
  return (
    <div className="content-page-header">
      <h5>
        {pageTitle} ({count})
      </h5>
      <div className="d-flex align-items-center">
          <Link to={addPageUrl} className="btn btn-sm btn-primary">
          <div className="d-flex align-items-center">
            <i className="fa fa-plus-circle me-2" aria-hidden="true"></i>
            Add
          </div>
        </Link>
      </div>
    </div>
  );
};
export default PageHeader;
